const GenericStar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5227 7.55188C15.0692 6.23782 16.9308 6.23782 17.4773 7.55189L18.7987 10.729C19.0291 11.2829 19.5501 11.6615 20.1482 11.7094L23.5781 11.9844C24.9968 12.0981 25.572 13.8685 24.4911 14.7944L21.8779 17.0329C21.4222 17.4232 21.2232 18.0357 21.3625 18.6193L22.1608 21.9663C22.4911 23.3507 20.9851 24.4449 19.7705 23.703L16.834 21.9094C16.322 21.5967 15.678 21.5967 15.166 21.9094L12.2295 23.703C11.0149 24.4449 9.50893 23.3507 9.83915 21.9663L10.6375 18.6193C10.7768 18.0357 10.5778 17.4232 10.1221 17.0329L7.50885 14.7944C6.42799 13.8685 7.00323 12.0981 8.42188 11.9844L11.8518 11.7094C12.4499 11.6615 12.9709 11.2829 13.2013 10.729L14.5227 7.55188Z"
      stroke="currentColor"
    />
  </svg>
);

export default GenericStar;
